<template>
  <Fragment>
    <img class="blue_bg" alt :src="img" />
    <div class="info">
      <h3>
        <span>
          {{ title }}
        </span>
      </h3>
    </div>
  </Fragment>
</template>

<script>
import { Fragment } from 'vue-fragment';

export default {
  name: 'BannerItem',
  props: ['title', 'img'],
  components: {
    Fragment
  }
};
</script>

<style lang="scss" scoped>
@import './bannerItem.scss';
</style>
